import React, { useState } from "react";
import { IProject } from "../../interfaces/IProject";
import { useGetBankAccounts, useGetInvoicesByProject, useUpdateInvoice } from "../../hooks/data/data_invoice";
import { Button, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { ErrorTryRefetch } from "../core/ErrorTryRefetch";
import { IInvoiceState } from "../../interfaces/IInvoiceState";
import { IInvoiceType } from "../../interfaces/IInvoiceType";
import { InvoiceCreateDialog } from "./InvoiceCreateDialog";
import { IFeedback } from "../../interfaces/IFeedback";
import { CustomSnackbar } from "../core/Snackbar";
import { InvoiceRow } from "./InvoiceRow";


interface IProps {
    project: IProject;
    invoiceStates: IInvoiceState[];
    invoiceTypes: IInvoiceType[];
}

export const InvoiceTab:React.FC<IProps> = ({
    project,
    invoiceStates,
    invoiceTypes
}) => {
    const { invoices, isLoadingInvoices, refetchInvoices } = useGetInvoicesByProject(project.id);
    const { bankAccounts, isLoadingBankAccounts, refetchBankAccounts } = useGetBankAccounts();
    //
    const [feedback, setFeedback] = useState<IFeedback>({ open: false, message: "", severity: "info" });

    const refetchAll = () => {
        refetchInvoices()
    }

    

    if (isLoadingInvoices || isLoadingBankAccounts) {
        return <CircularProgress/>
    }
    if (!invoices || !bankAccounts) {
        <ErrorTryRefetch
            refetchFunction={refetchAll}
        />
    }

    return(
        <>
            <CustomSnackbar feedback={feedback} setFeedback={setFeedback} />


            <Typography 
                variant="h5"
            >

                Rechnungen
                <InvoiceCreateDialog
                    invoiceStates={invoiceStates}
                    invoiceTypes={invoiceTypes}
                    project={project}
                    refetchFunction={() => refetchInvoices()}
                    setFeetback={setFeedback}
                />
            </Typography>

            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>RG-Nummer</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Titel</TableCell>
                        <TableCell>RG-Ausgang</TableCell>
                        <TableCell>RG-Summe</TableCell>
                        <TableCell>Aktionen</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoices?.map(inv =>
                        <InvoiceRow
                            key={`re-row-${inv.id}`}
                            invoice={inv}
                            invoices={invoices}
                            bankAccounts={bankAccounts || []}
                            invStates={invoiceStates}
                            invTypes={invoiceTypes}
                            setFeetback={setFeedback}
                            refetchFunction={() => refetchInvoices()}
                        />
                    )}
                </TableBody>
            </Table>


        </>
    )
}